import { createAction } from 'redux-actions';
import api from '../../services/api';
import {
  SAVE_CONTACT,
  SAVE_CONTACT_SUCCESS,
  SAVE_CONTACT_FAILURE,
  ADD_CONTACT_TO_THE_LIST,
  UPDATE_CONTACT_IN_THE_LIST
} from './actionTypes';
import { change } from 'redux-form';

//<<<---SAVE-CONTACT--->>>
export const saveContactInProgress = createAction(SAVE_CONTACT);
export const saveContactSuccess = createAction(SAVE_CONTACT_SUCCESS);
export const addContactToTheList = createAction(ADD_CONTACT_TO_THE_LIST);
export const saveContactFailure = createAction(SAVE_CONTACT_FAILURE);

export const saveContact = (formData, lang, callback) => async dispatch => {
  dispatch(saveContactInProgress());
  try {
    const res = await api.post(`contact/${lang}`, formData);
    const { data } = res;
    callback();
    dispatch(saveContactSuccess(data));
    dispatch(addContactToTheList(data));
  } catch (error) {
    dispatch(saveContactFailure(error));
  }
};

//<<<---UPDATE-CONTACT--->>>
export const updateContactInTheList = createAction(UPDATE_CONTACT_IN_THE_LIST);

export const updateContact = (
  formData,
  id,
  lang,
  callback
) => async dispatch => {
  dispatch(saveContactInProgress());
  try {
    const res = await api.post(`contact/${id}/${lang}`, formData, {
      headers: { 'X-HTTP-Method-Override': 'PUT' }
    });
    const { data } = res;
    callback();
    dispatch(saveContactSuccess(data));
    dispatch(updateContactInTheList(data));
  } catch (error) {
    dispatch(saveContactFailure(error));
  }
};

export const setValueToEmptyObject = (formName, fieldName) => () =>
  change(formName, fieldName, {});



// WEBPACK FOOTER //
// ./src/modules/ContactForm/actions.js